import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractUserRelatedDataService } from '@y42/feature';
import { IntegrationQuery, IntegrationState, IntegrationStore } from '../../state/datasource';

@Injectable({ providedIn: 'root' })
export class IntegrationUserDataService extends AbstractUserRelatedDataService<IntegrationState> {
  constructor(readonly http: HttpClient, readonly store: IntegrationStore, readonly query: IntegrationQuery) {
    super({
      http,
      store,
      query,
      URLs: {
        last_used: 'integration-lastseen',
        starred: 'integration-starred',
      },
    });
  }
}
